module.exports = __webpack_public_path__ + "img/subscriptions.3f48953e.svg";